<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard">
        <div class="mainDivHeader">
            <div class="leftdiv">
                <h4>Matches - {{username}} <span class="badge">{{totalRecords }}</span></h4>
            </div>
            <div class="rightDiv">
            </div>
        </div>
        <div class="mainDivBody">
            <div class="card p-p-0 border-0 shadow-none admin-mathes-div ">
                <p-tabView (onChange)="onChangeTab($event)">
                    <p-tabPanel header="Upcoming">
                        <div class=" col-md-12 p-p-0 accordian-body collapse show" id="compare-2">
                            <div class="col-md-12 p-p-0">
                                <div class="compare-table-inner-div">
                                    <div class="finished-wrapper">
                                        <div class="not-found-section" *ngIf="totalupcommingmatchCount ==0">
                                            <div class="col-md-12 not-found-body">
                                                <img src="assets/img/logo/not-found.gif" alt="">
                                                <h4>Sorry! No Upcoming Matches </h4>
                                                <div class="col-md-12">
                                                    <!-- <button (click)="clickTournament()">Let's Play Match</button> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="matches-container" *ngIf="totalupcommingmatchCount != 0">
                                            <ul class="torunamentsHistoryList">
                                                <li *ngFor="let upcommingMatch of upcommingmatchList">
                                                    <div class="tournamenntBody">
                                                        <div class="mainTopHeaderBadgd">
                                                            <div class="title">
                                                                Tournament
                                                            </div>
                                                        </div>
                                                        <div class="tbody-div">
                                                            <div class="title">
                                                                <h2> {{upcommingMatch.tournamentName}}</h2>
                                                            </div>
                                                            <div class="date d-flex align-items-center gap-2 mb-3 ">
                                                                <div class="icon">
                                                                    <img src="../../../../assets/images/backend-image/header/calenderdate.svg"
                                                                        alt="">
                                                                </div>
                                                                <div class="text">
                                                                    {{upcommingMatch.tournamentStartdate |
                                                                    date:'dd/MM/yyyy'}}
                                                                </div>
                                                            </div>
                                                            <div class="categories d-flex align-items-center gap-2 ">
                                                                <div class="icon">
                                                                    <img src="../../../../assets/images/backend-image/header/category.svg"
                                                                        alt="">
                                                                </div>
                                                                <div class="text">
                                                                    {{upcommingMatch.matchTypeName}} |
                                                                    {{upcommingMatch.ageGroupName}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>

                                            <div class="pagination-div col-md-12 d-flex justify-content-center">
                                                <p-paginator *ngIf="totalupcommingmatchCount != 0 " [rows]="4"
                                                    #paginator [totalRecords]="totalupcommingmatchCount"
                                                    (onPageChange)="loadUpcomingMatches($event)"
                                                    [rowsPerPageOptions]=" pagination"></p-paginator>
                                                <div *ngIf="totalupcommingmatchCount == 0">
                                                    <span>
                                                        There is no Up Coming Match.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>
                    <p-tabPanel header="History">
                        <div class=" col-md-12 accordian-body collapse p-p-0 show" id="compare-1"
                            style="margin-top: 0px;">
                            <div class="col-md-12 p-p-0">
                                <div class="compare-table-inner-div">
                                    <div class="not-found-section" *ngIf="totalpastMatchCount ==0">
                                            <div class="col-md-12 not-found-body">
                                                <img src="assets/img/logo/not-found.gif" alt="">
                                                <h4>Sorry! No Past Matches </h4>
                                                <div class="col-md-12">
                                                    <!-- <button (click)="clickTournament()">Let's Play Match</button> -->
                                                </div>
                                            </div>
                                        </div> 
                                    <div class="matches-container" #dt *ngIf="totalpastMatchCount != 0"
                                        [paginator]="true" [rows]="4" [rowsPerPageOptions]="paginationOption"
                                        [totalRecords]="totalRecords">
                                        <ul class="torunamentsHistoryList">
                                            <li *ngFor="let pastMatch of pastMatchList">
                                                <div class="tournamenntBody">
                                                    <div class="mainTopHeaderBadgd">
                                                        <div class="title">
                                                            Tournament
                                                        </div>
                                                    </div>
                                                    <div class="tbody-div">
                                                        <div class="title">
                                                            <h2> {{pastMatch.tournamentName}}</h2>
                                                        </div>
                                                        <div class="date d-flex align-items-center gap-2 mb-3 ">
                                                            <div class="icon">
                                                                <img src="../../../../assets/images/backend-image/header/calenderdate.svg"
                                                                    alt="">
                                                            </div>
                                                            <div class="text">
                                                                {{pastMatch.tournamentStartdate | date:'dd/MM/yyyy'}}
                                                            </div>
                                                        </div>
                                                        <div class="categories d-flex align-items-center gap-2 mb-3">
                                                            <div class="icon">
                                                                <img src="../../../../assets/images/backend-image/header/category.svg"
                                                                    alt="">
                                                            </div>
                                                            <div class="text">
                                                                {{pastMatch.matchTypeName}} | {{pastMatch.ageGroupName}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="boxFooter">
                                                        <div class="rin-matches-card-body-container">
                                                            <div class="rin-matches-card-participant-names-container">
                                                                <span class="rin-match-participant-name-wrapper">
                                                                    <img src="../../../../assets/images/backend-image/common-images/flag.svg" alt=""
                                                                        class="flag">

                                                                    {{playerName}}

                                                                </span> <!----> <!----> 
                                                                <!-- <span *ngIf="pastMatch.playerName"
                                                                    class="rin-match-participant-name-wrapper is-winner">
                                                                    <img src="../../../../assets/images/backend-image/common-images/flag.svg" alt=""
                                                                        class="flag"> 
                                                                    {{pastMatch.playerName}}

                                                                </span> -->
                                                                <!-- <span *ngIf=" !pastMatch.playerName"
                                                                    class="rin-match-participant-name-wrapper is-winner">
                                                                    <img src="assets/img/players/flag2.png" alt=""
                                                                        class="flag">

                                                                    bye</span> -->
                                                                    <!---->
                                                            </div>
                                                            <div class="rin-matches-score-container">
                                                                <div class="rin-matches-scorebox">
                                                                    <span>{{pastMatch.player1val}}</span>
                                                                    <span>{{pastMatch.player2val}}</span>
                                                                </div>
                                                            </div> <!---->
                                                        </div>

                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <!-- <div class="rin-matches-card rin-card rin-card-bg-secondary rin-card-no-shadow rin-card-border"
                                            *ngFor="let pastMatch of pastMatchList">
                                            <div class="rin-card-title">
                                                <div class="match-title-container">
                                                    <div class="matches-header-left-side"><span
                                                            class="rin-type-label tournament">
                                                            tournament
                                                        </span>
                                                        <div class="rin-matches-name-wrapper"><i
                                                                class='bx bxs-tennis-ball'></i>
                                                            &nbsp;
                                                            <a (click)="onclickTournamentdetails(upcommingMatch.tournamentId)"
                                                                class="rin-matches-title underlined showCursor">
                                                                {{pastMatch.tournamentName}}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="rin-card-header">
                                                <div class="match-header-content">
                                                    <div class="header-item"><i class='bx bx-calendar'></i>
                                                        <div class="rin-matches-max-width">
                                                            {{pastMatch.tournamentStartdate | date:'dd/MM/yyyy'}}
                                                        </div>
                                                    </div>
                                                    <div class="header-item"><i class='bx bx-time-five'></i>
                                                        <div class="rin-matches-max-width">
                                                            {{pastMatch.matchTypeName}} | {{pastMatch.ageGroupName}}
                                                        </div>
                                                    </div>
                                                </div>  
                                                <hr class="upper-row">
                                            </div>
                                            <div class="rin-card-body">

                                            </div>
                                        </div> --> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-tabPanel>
                </p-tabView>
            </div>
        </div>
    </div>
</div>